// removed by extract-text-webpack-plugin
module.exports = {"breadcrumb":"breadcrumb__32Zjm"};


//////////////////
// WEBPACK FOOTER
// ./styles/elss/breadcrumb.scss
// module id = 1261
// module chunks = 68